import { combineDataProviders, DataProvider } from "react-admin";

import adminUserDataProvider from "../adminUserDataProvider";
import adminCompanyDataProvider from "../adminCompanyDataProvider";
import adminWebsiteDataProvider from "../adminWebsiteDataProvider";
import adminUrlDataProvider from "../adminUrlDataProvider";
import adminTelephoneDataProvider from "../adminTelephoneDataProvider";
import adminEmailDataProvider from "../adminEmailDataProvider";
import adminAddressDataProvider from "../adminAddressDataProvider";
import adminSocialDataProvider from "../adminSocialDataProvider";
import adminPeopleDataProvider from "../adminPeopleDataProvider";
import adminEmployeeDataProvider from "../adminEmployeeDataProvider";
import adminCompaniesHouseDataProvider from "../adminCompaniesHouseDataProvider";
import adminCompaniesHouseAddressDataProvider from "../adminCompaniesHouseAddressDataProvider";
import adminCompaniesHousePeopleDataProvider from "../adminCompaniesHousePeopleDataProvider";
import adminCompaniesHouseFilingHistoryDataProvider from "../adminCompaniesHouseFilingHistoryDataProvider";
import adminSettingsDataProvider from '../adminSettingsDataProvider';
import operatorsDataProvider from "../operatorsDataProvider";
import workflowDataProvider from "../workflowDataProvider";
import promptDataProvider from "../promptDataProvider";
import adminAiSystemAgentToolsProvider from "../adminAiSystemAgentToolsProvider";
import modelSchemaDataProvider from "../modelSchemaDataProvider";
import llmModelPriceDataProvider from "../llmModelPriceDataProvider";
import workflowExecutionDataProvider from "../workflowExecutionDataProvider";
import nokwebsiteDataProvider from "../nokwebsiteDataProvider";
import industryDataProvider from "../industryDataProvider";
import nokPersonaDataProvider from "../nokPersonaDataProvider";
import tokenHistoryDataProvider from "../tokenHistoryDataProvider";
import cmsBlockDataProvider from "../cmsBlockDataProvider";
import nokEmailSignatureDataProvider from "../nokEmailSignatureDataProvider";
import emailMessageDataProvider from "../EmailMessageDataProvider";
import nokEmailTemplateDataProvider from "../nokEmailTemplateDataProvider";
import emailMetricDataProvider from "../emailMetricDataProvider";
import nokMiniDataProvider from "../nokMiniDataProvider";
import customerDataProvider from "../customerDataProvider";
import subscriptionProductDataProvider from "../subscriptionProductDataProvider";
import subscriptionProductPriceDataProvider from "../subscriptionProductPriceDataProvider";
import customerAddressDataProvider from "../customerAddressDataProvider";
import customerAccountDataProvider from "../customerAccountDataProvider";
import customerActivityMonitorDataProvider from "../customerActivityMonitorDataProvider";
import subscriptionDataProvider from "../subscriptionDataProvider";
import subscriptionInvoicesDataProvider from "../subscriptionInvoicesDataProvider";
import subscriptionInvoiceItemDataProvider from "../subscriptionInvoiceItemDataProvider";
import couponDataProvider from "../couponDataProvider";
import emailFinderProcessDataProvider from "../emailFinderProcessDataProvider";
import emailFinderResultsDataProvider from "../emailFinderResultsDataProvider";
import enterpriseRequestDataProvider from "../enterpriseRequestDataProvider";
import customerTutorialDataProvider from "../customerTutorialDataProvider";
import contactFormDataProvider from "../contactFormDataProvider";
import mysteryShopperDataProvider from "../mysteryShopperDataProvider";
import mysteryShopperResultDataProvider from "../mysteryShopperResultDataProvider";
import subscriptionInvoiceRefundDataProvider from "../subscriptionInvoiceRefundDataProvider";
import complianceSnifferDataProvider from "../complianceSnifferDataProvider";
import nokProvider from "../nokDataProvider";
import complianceSnifferResultDataProvider from "../complianceSnifferResultDataProvider";
import miniGradeDataProvider from "../miniGradeDataProvider";
import miniResultsDataProvider from "../miniResultsDataProvider";
import salesConversationDataProvider from "../salesConversationDataProvider";
import nokProcessingFailureDataProvider from "../nokProcessingFailureDataProvider";
import adminRoleDataProvider from "../adminRoleDataProvider";

export const dataProvider: DataProvider = combineDataProviders( (resource: string): DataProvider => {
    switch(resource) {
        case 'admin_users':
            return adminUserDataProvider;
        case 'admin_roles':
            return adminRoleDataProvider;
        case 'companies':
            return adminCompanyDataProvider;
        case 'websites':
            return adminWebsiteDataProvider;
        case 'urls':
            return adminUrlDataProvider;
        case 'telephones':
            return adminTelephoneDataProvider;
        case 'emails':
            return adminEmailDataProvider;
        case 'addresses':
            return adminAddressDataProvider;
        case 'social_media':
            return adminSocialDataProvider;
        case 'contacts':
            return adminPeopleDataProvider;
        case 'employees':
            return adminEmployeeDataProvider;
        case 'companies_houses':
            return adminCompaniesHouseDataProvider;
        case 'companies_house_addresses':
            return adminCompaniesHouseAddressDataProvider;
        case 'companies_house_peoples':
            return adminCompaniesHousePeopleDataProvider;
        case 'filing_histories': // Companies house fillings
            return adminCompaniesHouseFilingHistoryDataProvider;
        case 'settings':
            return adminSettingsDataProvider;
        case 'operators':
            return operatorsDataProvider;
        case 'workflows':
            return workflowDataProvider;
        case 'tools':
            return adminAiSystemAgentToolsProvider;
        case 'prompts':
            return promptDataProvider;
        case 'model_schemas':
            return modelSchemaDataProvider;
        case 'llm_model_prices':
            return llmModelPriceDataProvider;
        case 'workflow_executions':
            return workflowExecutionDataProvider;
        case 'nok_websites':
            return nokwebsiteDataProvider;
        case 'industries':
            return industryDataProvider;
        case 'nok_personas':
            return nokPersonaDataProvider;
        case 'token_histories':
            return tokenHistoryDataProvider;
        case 'cms_blocks':
            return cmsBlockDataProvider;
        case 'nok_email_signatures':
            return nokEmailSignatureDataProvider;
        case 'email_messages':
            return emailMessageDataProvider;
        case 'nok_email_templates':
            return nokEmailTemplateDataProvider;
        case 'email_metrics':
            return emailMetricDataProvider;
        case 'nok_minis':
            return nokMiniDataProvider;
        case 'customers':
            return customerDataProvider;
        case 'subscription_products':
            return subscriptionProductDataProvider;
        case 'subscription_product_prices':
            return subscriptionProductPriceDataProvider;
        case 'customer_addresses':
            return customerAddressDataProvider;
        case 'customer_accounts':
            return customerAccountDataProvider;
        case 'customer_activity_monitors':
            return customerActivityMonitorDataProvider;
        case 'subscriptions':
            return subscriptionDataProvider;
        case 'subscription_invoices':
            return subscriptionInvoicesDataProvider;
        case 'subscription_invoice_items':
            return subscriptionInvoiceItemDataProvider;
        case 'coupons':
            return couponDataProvider;
        case 'email_finders':
            return emailFinderProcessDataProvider;
        case 'email_finder_results':
            return emailFinderResultsDataProvider;
        case 'enterprise_requests':
            return enterpriseRequestDataProvider;
        case 'customer_tutorials':
            return customerTutorialDataProvider;
        case 'sales_conversations':
            return salesConversationDataProvider;
        case 'contact_forms':
            return contactFormDataProvider;
        case 'mystery_shoppers':
            return mysteryShopperDataProvider;
        case 'mystery_shopper_results':
            return mysteryShopperResultDataProvider;
        case 'subscription_refunds':
            return subscriptionInvoiceRefundDataProvider;
        case "compliance_sniffers":
            return complianceSnifferDataProvider;
        case 'noks':
            return nokProvider;
        case 'compliance_sniffer_results':
            return complianceSnifferResultDataProvider;
        case 'nok_processing_failures':
            return nokProcessingFailureDataProvider;
        case 'mini_grades':
            return miniGradeDataProvider;
        case 'mini_results':
            return miniResultsDataProvider;
    }
});